<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
          </div>
          <ul class="top_ul">
            <li @click="dialogVisible = true">
              <a href="#">登录</a>
            </li>
            <li>|</li>
            <li @click="dialogVisible1 = true">
              <a href="#">注册</a>
            </li>
            <li>
              <a href="https://coc.sqifu.com" target="_blank">商会后台</a>
            </li>
            <router-link :to="{path:'/fuwushang'}" tag="li">
              <a href="#">卖家中心</a>
            </router-link>
            <li>
              <a href="http://zf.sqifu.com">政府机构</a>
            </li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="cent">
      <img src="../../assets/img/zhengwu/government_bg_top.png" alt />
      <div class="cent_1">
        <p>{{lisit[0].fullname}}</p>
        <p>
          <el-dropdown>
            <span class="el-dropdown-link">切换城市</span>
            <el-dropdown-menu slot="dropdown" class="xiala">
              <el-dropdown-item v-for="(item,index) in lisit" :key="index">{{item.fullname}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </p>
      </div>
    </div>-->
    <div class="cent">
      <img src="../../assets/img/zhengwu/government_bg_top.png" alt />
      <div class="cent_1">
        <!-- <p>天津市河西区企业服务平台</p> -->
        <!-- <p>{{lisit[num].fullname}}</p> -->
        <p>
          <!-- <el-dropdown trigger="click">
            <span class="el-dropdown-link">切换平台</span>
            <el-dropdown-menu slot="dropdown" class="xiala">
              <el-dropdown-item
                v-for="(item,index) in lisit"
                :key="index"
                @click.native="change(item.id,index)"
              >{{item.fullname}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>-->
          <!-- <el-dropdown trigger="click">
            <span class="el-dropdown-link">切换平台</span>
            <el-dropdown-menu slot="dropdown" class="xiala">
              <el-dropdown-item
                v-for="(item,index) in lisit"
                :key="index"
                @click.native="change(item.id,index)"
                style="padding:0;"
              >{{item.fullname}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>-->
        </p>
      </div>
    </div>
    <div class="cent1">
      <div class="cent1_1">
        <ul>
          <li @click="zhngwu()">
            <a href="#">首页</a>
          </li>
          <li @click="zhitongche()" style="background: #e40000;">
            <a href="#">政企直通车</a>
          </li>
          <li @click="business()">
            <a href="#">办事指南</a>
          </li>
          <li @click="shanhui()">
            <a href="#">商会</a>
          </li>
          <li @click="fuwu()">
            <a href="#">服务</a>
          </li>
          <li @click="guanyu()">
            <a href="#">关于平台</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 内容 -->
    <div class="content">
      <div class="content_1">
        <div class="content_top">
          <ul>
            <router-link :to="{name:'zhengwu'}" tag="li">
              <a href="#">当前位置：首页</a>
            </router-link>
            <li>
              <i class="el-icon-arrow-right"></i>
            </li>
            <router-link :to="{name:'zhitongche'}" tag="li">
              <a href="#">政务直通车</a>
            </router-link>
            <li>
              <i class="el-icon-arrow-right"></i>
            </li>
            <li :to="{name:'zhitongche'}" tag="li">
              <a href="#">政务机构名称</a>
            </li>
            <li>
              <i class="el-icon-arrow-right"></i>
            </li>
            <li>
              <a href="#">我要咨询</a>
            </li>
          </ul>
        </div>
        <div class="conetent_cent">
          <div class="conetent_cent_1">
            <div class="conetent_cent_one">
              <p>
                <span style="color:#FF4D43">*</span>提问标题:
              </p>
              <el-input v-model="from.questions_content" placeholder="请输入内容" class="input"></el-input>
            </div>
            <div class="conetent_cent_two">
              <p>
                <span style="color:#FF4D43">*</span>问题描述:
              </p>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                class="input1"
                v-model="from.content"
              ></el-input>
            </div>
            <div class="conetent_cent_four">
              <p>
                <span style="color:#FF4D43">*</span>上传图片:
              </p>
              <el-form :model="article" label-width="120px">
                <el-form-item label style="width: 1000px;" prop="image">
                  <template>
                    <el-upload
                      :action="upImgUrl"
                      list-type="picture-card"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove"
                      :on-success="handleAvatarSuccess"
                      :on-exceed="handleExceed"
                      :limit="4"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible2">
                      <img width="100%" :src="imgPath + article.image" alt />
                    </el-dialog>
                  </template>
                </el-form-item>
              </el-form>
            </div>
            <div class="conetent_cent_one">
              <p>
                <span style="color:#FF4D43">*</span>手机号:
              </p>
              <el-input placeholder="请输入内容" class="input2" v-model="from.phone"></el-input>
            </div>
            <div class="conetent_cent_one">
              <p>
                <span style="color:#FF4D43">*</span>邮箱:
              </p>
              <el-input placeholder="请输入内容" class="input2" v-model="from.email"></el-input>
            </div>
          </div>
        </div>
        <div class="content_floor" @click="idem(mechanisms_id,business_user_id)">
          <a href="#">提交</a>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor()">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">登录</a>
        </div>
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==0">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==1">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">登录</a>
        </div>
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==1">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==0">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createContract, uploadContractImg } from "@/http/api";
import { getLoginphone, getLogin, getRegionList, getLogon } from "@/http/api";
import VueNeditorWrap from "vue-neditor-wrap";
import editor from "@/config/editor";
import config from "@/config/index";
export default {
  components: {
    VueNeditorWrap
  },
  data() {
    return {
      value1: "",
      numm: 0,
      lisit: [],
      from: {
        questions_content: "",
        content: "",
        phone: "",
        email: ""
      },
      dialogVisible: false,
      upImgUrl: config.api + "/QuestionsUploadImage",
      imgPath: config.apiPath,
      article: {
        image: ""
      },
      //登录
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      num: 0,
      TIME_COUNT: 60, //验证码倒计时60s
      form: {
        phone: "",
        ecord: ""
      },
      formLogon: {
        phone: "",
        ecord: "",
        name: "",
        enterprise_name: "",
        office_address_province_id: "",
        detailed_address: ""
      },
      count: "",
      show: true,
      cang: false,
      num1: 2,
      options: [],
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      },
      //划过
      munn() {
        this.num1 = 1;
      },
      munn1() {
        this.num1 = 2;
      }
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    },
    getCitySubUsers() {
      this.id = localStorage.getItem("city_id");
      console.log(this.id);
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getCitySubUsersByCity",
        {
          city_id: this.id
        },
        "post"
      ).then(res => {
        this.lisit = res.data.data;
      });
    },
    idem(article) {
      this.id = localStorage.getItem("city_id");
      this.imember_idd = localStorage.getItem("member_id");
      this.name = localStorage.getItem("name");
      this.phone = localStorage.getItem("phone");
      this.mechanisms_id = this.$route.query.id;
      this.$http(
        "https://ctapi.sqifu.com/api/v1/createQuestions",
        {
          city_id: this.id,
          mechanisms_id: this.mechanisms_id,
          questions_content: this.from.questions_content,
          content: this.from.content,
          questions_username: this.name,
          questions_phone: this.phone,
          questions_id: this.imember_idd,
          email: this.from.email,
          image: "https://ctapi.sqifu.com/image/" + this.article.image
        },
        "post"
      ).then(res => {
        if (res.data.stateCode === 200) {
          this.$message({
            message: "咨询成功",
            type: "success"
          });
          this.$router.push({
            name:'zhitongche'
          })
        }
      });
    },
    handleRemove(file, fileList) {
      this.article.image = "";
    },
    handlePictureCardPreview(file) {
      this.dialogVisible2 = true;
    },
    handleAvatarSuccess(res, file) {
      this.article.image = res.data.path;
      console.log(this.article.image)
    },
    handleExceed(files, fileList) {
      this.$message.error("只能上传四张图片！");
    },
    zhitongche() {
      this.$router.push({
        name: "zhitongche"
      });
    },
    business() {
      this.$router.push({
        name: "business"
      });
    },
    shanhui() {
      this.$router.push({
        name: "shanhui"
      });
    },
    guanyu() {
      this.$router.push({
        name: "guanyupingtai"
      });
    },
    fuwu() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
           this.$router.push({
            name: "login"
          });
        } else {
          this.$router.push({
            name: "home"
          });
        }
      });
    },
    zhngwu() {
      this.$router.push({
        name: "zhengwu"
      });
    },
    //登录
    getCode(form) {
      if (!/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.form.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    login() {
      if (this.form.ecord == "") {
        this.$message({
          message: "请输入验证码"
        });
      } else {
        getLogin({
          phone: this.form.phone,
          ecord: this.form.ecord
        }).then(res => {
          console.log(res);
          this.login_login = res.data;
          console.log(this.login_login);
          if (res.data.errcode === 200) {
            this.dialogVisible = false;
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push({
              name: "home",
              query: {
                id: res.data.data.name,
                idimg: res.data.data.photo,
                token: res.data.data.token
              }
            });
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("phone", res.data.data.phone);
            localStorage.setItem("photo", res.data.data.photo);
            localStorage.setItem("member_id", res.data.data.member_id);
            localStorage.setItem("is_service", res.data.data.is_service);
          } else if (res.data.errcode == 406) {
            this.$message({
              message: "账号信息不存在，请先注册"
            });
          }
        });
      }
    },
    //注册并登录
    getCode1(formLogon) {
      if (!/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.formLogon.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getlogon() {
      getLogon({
        name: this.formLogon.name,
        phone: this.formLogon.phone,
        ecord: this.formLogon.ecord,
        enterprise_name: this.formLogon.enterprise_name,
        office_address_province_id: this.formLogon.office_address_province_id,
        detailed_address: this.formLogon.detailed_address
      }).then(res => {
        this.logon_logon = res.data.errcode;
        if (res.data.errcode == 200) {
          this.$router.push({
            name: "home",
            query: {
              id: this.formLogon.name
            }
          });
          localStorage.setItem("name", this.formLogon.name);
          localStorage.setItem("is_service", res.data.data.is_service);
        }
        if (res.data.errcode === 20001) {
          this.$message({
            message: "该手机号已经是会员",
            type: "success"
          });
        }
      });
    },
    handleChange(value) {
      console.log(value);
      let labels = this.$refs["cascaderAddr"].currentLables;
      console.log(this.$refs["cascaderAddr"]);
    },
    getRegion() {
      getRegionList({}).then(res => {
        console.log(res);
        this.options = res.data.data;
      });
    },
    checlogin() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checkislogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          this.$emit("header", false); //是否显示头部
        } else {
          this.$emit("header", true); //是否显示头部
        }
      });
    },
    floor() {
      this.$router.push({ name: "guanyu" });
    }
  },
  created() {
    var mechanisms_id = this.$route.query.id;
    console.log(this.$route.query.id);
    var business_user_id = this.$route.query.business_user_id;
    this.getCitySubUsers();
    this.idem(mechanisms_id, business_user_id);
    this.getRegion(); //城市
    this.checlogin();
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: auto;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.cent {
  width: 100%;
  height: 96px;
  position: relative;
}

.cent img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.cent_1 {
  width: 1200px;
  height: 96px;
  margin: 0 auto;
}

.cent_1 p:first-child {
  font-size: 32px;
  color: #fff;
  line-height: 96px;
  font-weight: 600;
  float: left;
}

.cent1 {
  width: 100%;
  height: 40px;
  background: #1369c0;
}

.cent1_1 {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.cent1_1 ul li {
  float: left;
  width: 199px;
  height: 40px;
  border-right: 1px solid #71a5d9;
  line-height: 40px;
  text-align: center;
}

.cent1_1 ul li:hover {
  background: #e40000;
  height: 40px;
  margin: 0;
  line-height: 40px;
}

.cent1_1 ul li a {
  width: 200px;
  color: #fff;
}

.cent1_1 ul li:nth-child(6) {
  border: 0;
}

.content {
  width: 100%;
  height: 694px;
}

.content_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}

.content_img {
  width: 690px;
  height: 430px;
  margin: 24px 0;
  float: left;
}

.content_img img {
  width: 690px;
  height: 430px;
}

.content_right {
  width: 510px;
  height: 430px;
  background: #fff;
  float: left;
  margin: 24px 0;
}

.content_right_1 {
  width: 450px;
  height: auto;
  margin: 20px auto;
  overflow: hidden;
}

.content_right_1 img {
  float: left;
  margin: 5px 0 0 0;
}

.content_right_1 p {
  font-size: 24px;
  color: #175294;
  float: left;
  padding: 0 13px;
}

.content_right_ul {
  width: 450px;
  height: 340px;
  margin: 0 auto;
}

.content_right_ul li {
  width: 100%;
  height: 80px;
  border-bottom: 1px dotted rgba(239, 239, 239, 1);
  margin-bottom: 13px;
}

.content_right_ul_left {
  width: 80px;
  height: 86px;
  float: left;
}

.content_right_ul_left p:first-child {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
}

.content_right_ul_left p:last-child {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(199, 199, 199, 1);
  line-height: 30px;
}
.content_right_ul_right {
  width: 361px;
  height: 86px;
  float: right;
}

.content_right_ul_right p:last-child {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}

.content_right_ul_right p a {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
}

.el-dropdown-link {
  font-size: 14px;
  cursor: pointer;
  color: #fff;
  padding: 0 10px;
  line-height: 120px;
}
.el-icon-arrow-down {
  font-size: 14px;
}

.xiala {
  width: 100px;
  text-align: center;
  margin-top: -40px;
  margin-left: 20px;
}

.content_top {
  width: 1200px;
  height: 40px;
  background: rgba(244, 245, 249, 1);
  border: 1px solid rgba(228, 228, 228, 1);
  border-radius: 2px;
  margin-bottom: 46px;
}

.content_top ul {
  padding: 0 10px;
}

.content_top ul li {
  float: left;
  color: #666666;
  line-height: 40px;
  margin-left: 5px;
}

.content_top ul li a {
  color: #666666;
}

.conetent_cent {
  width: 100%;
  height: auto;
}

.conetent_cent_1 {
  width: 858px;
  margin: 0 auto;
}

.conetent_cent_one {
  width: 100%;
  height: 36px;
  margin-bottom: 24px;
}

.conetent_cent_one p {
  width: 80px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_one span {
  margin-right: 5px;
}

.input {
  width: 699px;
}
.input2 {
  width: 336px;
}
.input2 {
  width: 336px;
}

.input1 {
  width: 699px;
  height: 66px;
}

.conetent_cent_two {
  width: 100%;
  height: 66px;
  margin-bottom: 34px;
}

.conetent_cent_four {
  width: 100%;
  height: 148px;
  margin-bottom: 34px;
}

.conetent_cent_four p {
  width: 80px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_four span {
  margin-right: 5px;
}

.conetent_cent_two p {
  width: 80px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_two span {
  margin-right: 5px;
}

.conetent_cent_three {
  width: 100%;
  height: 148px;
  margin-bottom: 24px;
}

.conetent_cent_three p {
  width: 80px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_three span {
  margin-right: 5px;
}

.content_floor {
  width: 260px;
  height: 44px;
  background: #007bff;
  border-radius: 5px;
  text-align: center;
  margin: 0 auto;
}

.content_floor a {
  color: #fff;
  line-height: 44px;
}

/* denglu */
.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  margin: 0 auto;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro1 {
  width: 322px;
  height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  position: relative;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}
.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  margin-bottom: 20px;
}

.login2_1_one {
  width: 322px;
  height: 550px;
  margin: 20px auto;
}

.login_three {
  width: 100%;
  height: 20px;
  margin-bottom: 20px;
}

.login_three img {
  float: left;
  padding: 0 5px 0 0;
}

.login_three p {
  float: left;
  line-height: 15px;
}

.top_ul li a {
  color: #666666;
}
</style>
 


// WEBPACK FOOTER //
// src/view/Zhengwu/Advice.vue